import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import auth from './modules/app/auth'
import errorHandler from './modules/app/errorHandler'
import notification from './modules/app/notification'
import company from './modules/company/company'
import codeService from './modules/codeService'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
    auth,
    errorHandler,
    notification,
    company,
    codeService
  },
})
